<template>
    <div>
        <div class="container container-fluid">
            <h1 class="page-heading mb-5">Stroke Group Detail</h1>
        </div>

        <!-- Detail -->
        <div class="container container-fluid">
            <div class="row">
                <div class="col-md-12">
                <!-- start content -->

                <!-- Title -->
                <div class="c-listing-header c-cta ">
                    <div class="c-label c-label--grey">Inactive</div>
                    <h1 class="h2">Texas Rehab Arlington Stroke Support Group</h1>
                    <div class="c-listing-header__cta-container">
                        <p class="c-listing-header__subheading">Medical Professionals</p>
                        <a href="#" class="c-listing-header__cta c-cta c-cta--arrow">Back to Search</a>
                    </div>
                </div>
                <!-- end title -->

                <!-- Card -->
                <div class="c-card c-card--horizontal">
                    <div class="row">
                        <div class="col-md-6">
                            <!-- Google Map sample -->
                            <aha-google-map :address="'1901 N MacArthur Blvd, Irving, TX, 75061'" :zoom="14" />
                        </div>

                        <div class="col-md-6">
                            <div class="c-card__content">
                                <h2 class="c-card__heading h3 text-primary">Address</h2>

                            <ul class="list-unstyled">
                                    <li class="h4 mb-1">1901 N MacArthur Blvd</li>
                                    <li>Baylor Scott & White Health</li>
                                    <li>Irving, TX, 75061</li>
                                </ul>

                                <div class="c-card__actions">
                                    <div class="c-card__action">
                                        <a href="http://www.google.com/maps/dir/1901+N+MacArthur+Blvd%2CIrving%2CTX%2C75061" target="_blank" class="c-cta c-cta--arrow h-theme--red">Directions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end Card -->

                
                <!-- Full Width 3 Cols -->
                <div class="l-promo row no-gutters">

                    <!-- start col -->
                    <div class="l-promo__col col-md">
                        <div class="c-text-promo">
                            <div class="c-text-promo__content">
                                <h2 class="h3 text-primary">Contact</h2>
                                <!-- content -->
                                <ul class="list-unstyled">
                                    <li class="h4 mb-1">Renee Vickers</li>
                                    <li>972-579-8511</li>
                                    <li><a href="mailto:renee.vickers@bswealth.org" type="email">renee.vickers@bswealth.org</a></li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                    <!-- end col -->

                    <!-- start col -->
                    <div class="l-promo__col col-md">
                        <div class="c-text-promo">
                            <div class="c-text-promo__content">
                                <h2 class="h3 text-primary">Meeting</h2>
                                <!-- content -->
                                
                                <ul class="list-unstyled">
                                    <li class="h4 mb-1">2nd Wednesday</li>
                                    <li>3:00-4:00PM</li>
                                    <li>Baylor Medical Hospital, 5th Floor Rehab Unit</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->

                </div>
                <!-- end l-promo -->

                <!-- Agenda -->
                <div class="row">
                    <div class="c-promo c-promo--shadow">
                        <div class="c-promo__content-container">
                            <div class="agenda">
                                <h2 class="h3">Agenda</h2>
                                <p class="text-muted">Meetings include a guest speaker with time for discussion afterwards.</p>
                            </div>
                            <div class="notes">
                                <h2 class="h3">Notes</h2>
                                <p class="text-muted">No charge for attendance. No advance notice required to attend.</p>
                            </div>
                            <div class="type">
                                <h2 class="h3">Type</h2>
                                <p class="text-muted">Support/Social/Edu/Therapeutic</p>
                            </div>
                            <div class="specialty">
                                <h2 class="h3">Specialty</h2>
                                <p class="text-muted">SURVIVORS, CAREGIVERS, PROS</p>
                            </div>
                        </div><!-- end content-container -->
                    </div>
                </div>
                <!-- end Agenda -->

                 <!-- Last Updated -->
                <p class="h-color--green mt-5 text-right">Last Reviewed: Jun 27, 2018</p>

                <!-- end content -->
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
  data () {
    return {
      modalShow: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// demo/pages/layouts/stroke-group-detail.vue